<template>
  <!-- GALLERY -->
  <div ref="tpl_root" component-name="carousel-bath-concept-zoom">
    <swiper-container
      init="false"
      events-prefix="swiper-"
      class="w-full h-full max-h-full"
    >
      <swiper-slide v-for="(item, i) in items" class="overflow-y-scroll">
        <img
          :alt="item.alt"
          :src="item.src"
          :width="item.width"
          :height="item.height"
          loading="eager"
          class="block max-w-full w-full h-auto object-contain object-bottom"
          :class="{
            'aspect-1/1': item.aspect === '1 / 1',
            'aspect-4/5': item.aspect === '4 / 5',
          }"
        />
      </swiper-slide>
    </swiper-container>
  </div>

  <!-- end GALLERY -->
</template>

<script setup>
const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  itemIndex: {
    type: Number,
    required: false,
    default: 0,
  },
});

const tpl_root = templateRef("tpl_root");
let swiperEl;

function destroySwiper() {
  swiperEl?.swiper?.destroy();
  swiperEl = null;
}

function getActiveSlideEl() {
  return tpl_root.value.querySelector(".swiper-slide-active");
}

watch(
  () => props.itemIndex,
  (newVal) => {
    swiperEl?.swiper?.slideTo(newVal);
  }
);

useSafeMountedEl(tpl_root, () => {
  swiperEl?.swiper?.destroy();
  swiperEl = null;

  swiperEl = tpl_root.value.querySelector("swiper-container");

  Object.assign(swiperEl, {
    slidesPerView: 1,
    speed: 275,
    loop: false,
    initialSlide: props.itemIndex,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 650,
    on: {
      init() {
        ScrollTrigger.refresh(true);
      },
      slideChangeTransitionEnd(swiper) {
        gsap.set(
          tpl_root.value.querySelectorAll(
            "swiper-slide:not(.swiper-slide-active)"
          ),
          { scrollTo: 0 }
        );
      },
    },
  });

  swiperEl.initialize();
});

defineExpose({ getActiveSlideEl });
</script>
